import styled from 'styled-components';
import { Bar } from '@elfsight/widget-modal';
import { createCustomCSSPrefixClassName } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from '../constants/meta';
import { useBarState } from './bar-state-provider';
import { MOCK_WIDGET_ID } from './constants';
import { BarElements } from './ui/bar-elements';

export function Widget() {
  const {
    layout,
    widgetId = MOCK_WIDGET_ID,
    renderThumbnailMode
  } = useSettings();
  const { isOpen } = useBarState();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );
  const barStateClassName = `es-announcement-bar-${
    isOpen ? 'opened' : 'closed'
  }`;
  const fullClassName = [customCSSPrefixClassName, barStateClassName].join(' ');

  if (renderThumbnailMode) {
    return (
      <div style={{ width: '600px' }} className={fullClassName}>
        <BarElements />
      </div>
    );
  }

  if (layout === 'inline') {
    return (
      <InlineContainer className={fullClassName}>
        <BarElements />
      </InlineContainer>
    );
  }

  return (
    <Bar mode={layout} className={barStateClassName}>
      <BarElements />
    </Bar>
  );
}

const InlineContainer = styled.div`
  width: 100%;
`;
